/**
 * @file DataCountLine.tsx
 * @description «Сейчас подходит: N — покажем M» у элементов «Товары»,
 * «Категории», «Статьи», «Отзывы» (phase19.16 Р2; контракт §16.1
 * `dataCounts` — сколько записей подходит сейчас без учёта limit, условия
 * как у витрины). Счётчик относится к сохранённым настройкам блока: если
 * форма изменена — подпись «по сохранённым настройкам». Нет числа — строки
 * нет; 0 — блок на сайте будет скрыт.
 */

import { cn } from "@/lib/utils";

const NOTHING_TO_SHOW_TEXT = "Сейчас нечего показать — блок на сайте будет скрыт. Выберите другой источник или добавьте вручную.";

interface Props {
  /** Сколько подходит; `undefined` — неизвестно (строки нет). */
  count: number | undefined;
  /** Сколько блок покажет самое большее. */
  limit: number;
  /** Форма изменена — число по сохранённым настройкам. */
  stale: boolean;
}

export function DataCountLine({ count, limit, stale }: Props) {
  if (count === undefined) return null;
  const note = stale ? " (по сохранённым настройкам)" : "";
  return (
    <p role="status" className={cn("type-caption", count === 0 ? "text-warning" : "text-on-surface-variant")}>
      {count === 0 ? NOTHING_TO_SHOW_TEXT : `Сейчас подходит: ${count} — покажем ${Math.min(count, limit)}`}
      {note}
    </p>
  );
}
